import { render, staticRenderFns } from "./list-agenda.vue?vue&type=template&id=d45b1ad8&"
import script from "./list-agenda.vue?vue&type=script&lang=js&"
export * from "./list-agenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports